import "../components/global.js";
import "../assets/css/bootstrap.css";
import Navbar from "../components/Navbar";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  loading,
  tokens,
  select_style,
  alert,
  success,
  alert_url,
  toFixed,
  GET,
  POST,
  PUT,
  DELETE,
  format_date,
  float,
  DatePicker,
  getStorage,
  roundToTwo,
  fieldSorter,
  total,
  success_url,
} from "../components/CustomComponent.js";
import React, { Component } from "react";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";
import excel_file from "../assets/files/TemplateBookbank.xlsx";
import { Modal } from "react-bootstrap";
import Tesseract from "tesseract.js";

const role = getStorage("role_detail");
const select_role = role ? role.find((item) => item.name === "record-water-usage") : null;
const view_r = select_role && select_role.role[0] === 1;
const create_r = select_role && select_role.role[1] === 1;

export default class RecordWaterUsage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      select_date: null,
      max_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      data_statement: [],
      data_bookbank: [],
      data_bookbank_remove: [],
      data_iw: [],
      start_date_statement: "",
      start_balance_statement: 0,
      last_balance_statement: 0,
      total_forward: 0,
      select_bookbank: -1,
      currentSheet_current: null,
      import_current: null,
      data_import_current: [],
      save: true,
      disabled: false,
      draggedIndex: null,
      balance_forward: 0,
      last_price: "",
      modal_remark: false,
      remark: "",
      bookbank_index: -1,
    };
    this.inputRefs = [];
    this.timeRefs = [];
    this.interval = null;
  }

  async componentDidMount() {
    loading(false); // ปิด loading ตั้งแต่เข้ามาหน้าครั้งแรก
    if (view_r) this.Get();
    setTimeout(() => this.inputRefs[1]?.focus(), 1000);

    this.Start();
    this.interval = setInterval(() => this.Start(), 30000);
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  Start = async () => {
    let user_id = getStorage("user_id");
    let user_type = getStorage("user_type");
    let result = await GET(tokens, "v1/TH/statement/section-list/" + getStorage("project_id"), null);

    if (result?.status && result?.data?.data?.length > 0) {
      let currentSection = result.data.data[0];
      if (currentSection.user_id === user_id) {
        await PUT(tokens, "v1/TH/statement/section-update", { section_id: currentSection.section_id, date: format_date(new Date(), "yyyy-mm-dd", "en"), time: format_date(new Date(), "hh:mm:ss", "en") });
      } else {
        let lastUpdate = format_date(currentSection.date + " " + currentSection.time, "date", "en");
        let now = new Date().getTime();

        if (now - lastUpdate > 60000) {
          await PUT(tokens, "v1/TH/statement/section-update", { section_id: currentSection.section_id, date: format_date(new Date(), "yyyy-mm-dd", "en"), time: format_date(new Date(), "hh:mm:ss", "en") });
        } else {
          clearInterval(this.interval);
          if (user_type !== "owner") {
            alert_url("warning", "แจ้งเตือน", "มีการทำยอดโดยผู้ใช้อื่น กรุณาตรวจสอบ", "/customer");
          } else {
            Swal.fire({
              icon: "warning",
              title: "มีการทำยอดโดยผู้ใช้อื่น",
              text: "มีการทำยอดโดยผู้ใช้อื่น ต้องการทำยอดต่อหรือไม่ หากทำยอดต่อผู้ใช้ก่อนหน้าจะไม่สามารถทำยอดต่อได้",
              showCancelButton: true,
              confirmButtonText: "ดำเนินการต่อ",
              cancelButtonText: "ยกเลิก",
            }).then(async (re) => {
              if (re.isConfirmed) {
                await PUT(tokens, "v1/TH/statement/section-update", { section_id: currentSection.section_id, date: format_date(new Date(), "yyyy-mm-dd", "en"), time: format_date(new Date(), "hh:mm:ss", "en") });
                this.Start();
                this.interval = setInterval(() => this.Start(), 30000);
              } else {
                window.location.href = "/customer";
              }
            });
          }
        }
      }
    } else {
      result = await POST(tokens, "v1/TH/statement/section-create/" + getStorage("project_id"), { date: format_date(new Date(), "yyyy-mm-dd", "en"), time: format_date(new Date(), "hh:mm:ss", "en") });
      if (result?.status) this.Start();
      else clearInterval(this.interval);
    }
  };

  Get = async () => {
    loading(true);
    let [result_last, result_setting] = await Promise.all([
      GET(tokens, "v1/TH/statement/daily-reconcile/last-data/" + getStorage("project_id"), null),
      GET(tokens, "v1/TH/water-manage/detail/" + getStorage("water_id"), null)
    ]);

    let select_date = this.state.select_date ? new Date(this.state.select_date) : (result_last.data.data ? new Date(new Date(result_last.data.data.date).setDate(new Date(result_last.data.data.date).getDate() + 1)) : new Date(result_setting?.data?.data?.start_date_statement));
    if (select_date.getTime() > new Date().getTime()) select_date = new Date();
    select_date = format_date(select_date, "yyyy-mm-dd", "en");

    let max_date = result_last.data.data ? new Date(new Date(result_last.data.data.date).setDate(new Date(result_last.data.data.date).getDate() + 1)) : new Date(result_setting?.data?.data?.start_date_statement);
    if (max_date.getTime() > new Date().getTime()) max_date = new Date();
    max_date = format_date(max_date, "yyyy-mm-dd", "en");

    let body_last = { page: 0, start_date: format_date(this.state.select_date, "yyyy-mm-dd", "en"), end_date: format_date(this.state.select_date, "yyyy-mm-dd", "en") };
    let body = { page: 0, start_date: select_date, end_date: select_date };

    let [result_current, result_daily, result_bookbank, result_iw] = await Promise.all([
      GET(tokens, "v1/TH/statement/daily-reconcile/list/" + getStorage("project_id"), body_last),
      GET(tokens, "v1/TH/statement/daily-reconcile/list/" + getStorage("project_id"), body),
      GET(tokens, "v1/TH/statement/list/" + getStorage("project_id"), body),
      GET(tokens, "v1/TH/record-receipt/statement/" + getStorage("project_id"), body)
    ]);

    let data_bookbank = result_bookbank?.data?.data || [];
    let start_date_statement = result_setting?.data?.data?.start_date_statement;
    let start_balance_statement = result_setting?.data?.data?.start_balance_statement;
    let last_balance_statement = result_current?.data?.data[0]?.total_forward || result_last?.data?.data?.total_forward || 0;
    
    let balance_forward = format_date(start_date_statement) === format_date(select_date) ? start_balance_statement : last_balance_statement;

    this.setState({
      data_bookbank,
      data_iw: Array.isArray(result_iw?.data?.data) ? [...result_iw.data.data].sort((a, b) => new Date(`${a.transfer_date}T${a.transfer_time}`) - new Date(`${b.transfer_date}T${b.transfer_time}`)) : [],
      start_date_statement, start_balance_statement, last_balance_statement, balance_forward,
      select_date: format_date(select_date, "yyyy-mm-dd", "en"),
      max_date, disabled: result_daily?.data?.data?.length > 0
    });
    loading(false);
  };

  updateBalances = (newBookbank = this.state.data_bookbank) => {
    let { start_date_statement, select_date, start_balance_statement, last_balance_statement } = this.state;
    let isSameDate = format_date(start_date_statement) === format_date(select_date);

    newBookbank.forEach((item, j) => {
      let prevBalance = j === 0 ? (isSameDate ? start_balance_statement : last_balance_statement) : newBookbank[j - 1].balance;
      item.balance = Number(prevBalance) + (Number(item.income) - Number(item.outcome));
    });
    return newBookbank;
  };

  getAlertData = () => {
    let diff_anount = this.state.data_bookbank.reduce((acc, item) => {
      let iw = this.state.data_iw.find((e) => e.iw_number === item.iw_number);
      return iw && Number(iw.total_final) !== Number(item.income) ? acc + 1 : acc;
    }, 0);

    return {
      date: this.state.select_date,
      waiting_receipt_amount: this.state.data_bookbank.filter((e) => e.status == "3").length,
      receipt_more_transfer_amount: this.state.data_iw.filter((e) => new Date(e.record_date).getTime() - new Date(e.transfer_date).getTime() > 3 * 24 * 60 * 60 * 1000).length,
      waiting_amount: this.state.data_iw.filter((item) => !this.state.data_bookbank.some((e) => e.iw_number === item.iw_number)).length,
      diff_anount,
      total_forward: this.state.data_bookbank.length === 0 ? Number(this.state.balance_forward) : Number(this.state.data_bookbank[this.state.data_bookbank.length - 1]?.balance || 0),
      status: "WAIT_APPROVE",
    };
  };

  showConfirmAlert = (data, confirmAction) => {
    Swal.fire({
      icon: "info",
      title: "ยืนยันการบันทึกข้อมูล",
      html: `
        <div class="text-left">
        <div class="d-flex justify-content-center"><div class="wpx-180">วันที่ทำการบันทึก</div><div class="wpx-100">${format_date(data.date)}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">จำนวนที่รอออกใบเสร็จ</div><div class="wpx-100">${data.waiting_receipt_amount}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">จำนวนที่ใบเสร็จมากกว่าวันที่โอน</div><div class="wpx-100">${data.receipt_more_transfer_amount}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">จำนวนที่รอยอดเงินโอน</div><div class="wpx-100">${data.waiting_amount}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">จำนวนที่ไม่ตรงกัน</div><div class="wpx-100">${data.diff_anount}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">ยอดที่ยกไป</div><div class="wpx-100">${toFixed(data.total_forward)}</div></div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "บันทึก",
      cancelButtonText: "ยกเลิก",
    }).then((re) => {
      if (re.isConfirmed) confirmAction();
    });
  };

  CreateUpdate = async () => {
    this.showConfirmAlert(this.getAlertData(), async () => {
      loading(true);
      this.setState({ save: false });
      let data = {
        data: this.state.data_bookbank.map((e, i) => ({
          bookbank_id: e.bookbank_id || "", date: e.date || "", time: e.time || "", remark: e.remark || "",
          income: Number(e.income), outcome: Number(e.outcome), balance: Number(e.balance),
          iw_number: e.iw_number || "", status: e.status || "", record_name: e.record_name, seq: i + 1,
        })),
      };
      
      let result = await POST(tokens, "v1/TH/statement/create-update/" + getStorage("project_id"), data);
      if (this.state.data_bookbank_remove.length > 0) {
        await Promise.all(this.state.data_bookbank_remove.map((e) => this.Delete(e)));
      }
      loading(false);
      if (result?.status) success_url("/bookbank");
    });
  };

  SendData = async () => {
    if (getStorage("user_type") !== "owner" && this.state.data_iw.some((item) => !this.state.data_bookbank.some((e) => e.iw_number === item.iw_number))) {
      alert("warning", "แจ้งเตือน", 'ไม่สามารถนำส่งได้ หากมีรายการ "รอเงินโอน" กรุณายกเลิกรายการนั้นก่อนดำเนินการนำส่ง');
      return;
    }
    
    let alertData = this.getAlertData();
    this.showConfirmAlert(alertData, async () => {
      loading(true);
      await POST(tokens, "v1/TH/statement/daily-reconcile/create/" + getStorage("project_id"), alertData);
      loading(false);
      success_url("/bookbank");
    });
  };

  Delete = async (id) => {
    await DELETE(tokens, "v1/TH/statement/delete/" + id, null);
  };

  getNewRow = () => ({
    date: this.state.select_date, time: "", income: 0, outcome: 0, balance: 0, iw_number: "", status: "2", remark: "",
    record_name: [{ name: getStorage("full_name"), status: "", record_time: format_date(new Date(), "yyyy-mm-dd", "en") }],
  });

  handleInputEnter = (event, index, isTime = false) => {
    if (event.key === "Enter") {
      event.preventDefault();
      let { data_bookbank } = this.state;
      let isLast = isTime ? data_bookbank.length === index : data_bookbank.length * 2 === index;

      if (isLast) {
        data_bookbank.push(this.getNewRow());
        this.setState({ save: false, data_bookbank: this.updateBalances(data_bookbank) });
      }
      setTimeout(() => {
        const nextInput = isTime ? this.timeRefs[index + 1] : this.inputRefs[index + 1];
        if (nextInput) nextInput.focus();
      }, 100);
    }
  };

  Sheet = () => {
    let result = generateObjects(this.state.currentSheet_current).filter((item) => item["IW"] !== "ข้อมูลตัวอย่าง");
    if (result.length === 0) return;

    let day = String(result[0]["วันที่"]).padStart(2, '0');
    let month = String(result[0]["เดือน"]).padStart(2, '0');
    let year = String(result[0]["ปี (พ.ศ.)"]);
    let first_date = `${year < 2100 ? year : year - 543}-${month}-${day}`;

    if (format_date(first_date) !== format_date(this.state.select_date)) {
      alert("warning", "แจ้งเตือน", "วันที่ใน Excel ไม่ตรงกับ วันที่เลือก");
      return;
    }

    let data = result.filter((item) => item["วันที่"] !== "").map((item) => {
      let d = String(item["วันที่"]).padStart(2, '0');
      let m = String(item["เดือน"]).padStart(2, '0');
      let y = String(item["ปี (พ.ศ.)"]);
      let timeStr = item["เวลา"] ? item["เวลา"].replaceAll(".", ":") : "";

      if (timeStr && !/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(timeStr)) {
        alert("warning", "แจ้งเตือน", 'รูปแบบ "เวลา" ไม่ถูกต้อง');
        return null;
      }
      
      return {
        date: format_date(`${y < 2100 ? y : y - 543}-${m}-${d}`, "yyyy-mm-dd", "en"),
        time: timeStr,
        income: item["เงินเข้า"] ? Number(item["เงินเข้า"]) : 0,
        outcome: item["เงินออก"] ? Number(item["เงินออก"]) : 0,
        balance: 0, iw_number: item["IW"] || "", status: item["สถานะ"] || "2",
        record_name: [{ name: getStorage("full_name"), status: "2", record_time: format_date(new Date(), "yyyy-mm-dd", "en") }],
      };
    }).filter(Boolean);

    this.setState({ data_bookbank: this.updateBalances(data), save: false });
  };

  import_file = (e) => {
    readFile(e.target.files[0]).then((readedData) => {
      this.setState({ import_current: readedData });
      setTimeout(() => this.Sheet(), 100);
    }).catch(console.error);
    e.target.value = "";
  };

  onDragStart = (index) => this.setState({ draggedIndex: index });
  onDragOver = (e) => e.preventDefault();
  onDrop = (dropIndex) => {
    const { data_bookbank, draggedIndex } = this.state;
    if (draggedIndex === null || draggedIndex === dropIndex) return;

    const newRows = [...data_bookbank];
    const [draggedRow] = newRows.splice(draggedIndex, 1);
    newRows.splice(dropIndex, 0, draggedRow);

    this.setState({ data_bookbank: this.updateBalances(newRows), draggedIndex: null, save: false });
  };

  render() {
    let { data_bookbank, data_iw, start_date_statement, max_date, select_date, select_bookbank, disabled, draggedIndex, balance_forward, save, last_price, modal_remark, remark, bookbank_index } = this.state;
    
    if (!start_date_statement) {
      return (
        <div className="w-100 min-vh-100 fade-in">
          <Navbar page1="หน้าหลัก" page2="บันทึกรายการ statement" />
          <div className="body">
            <div className="w-100 min-vh-100 d-flex justify-content-center align-items-center">
              <div className="text-center">
                <h3 className="fw-bold">ไม่สามารถใช้งานได้</h3>
                <label>ยังไม่ได้ตั้งค่า เดือน/ปีเริ่มต้น รายการ Statement</label><br /><br />
                <button className="btn btn-primary px-4" onClick={() => window.location.href = "/manage-water"}>ไปหน้าตั้งค่า</button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="บันทึกรายการ statement" />
        <div className="body">
          <div className="p-3 pb-5">
            <div className="w-100 mb-5">
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-wrap mx-0 align-items-center w-100 mb-3">
                  <h4 className="fw-bold mb-0 mr-3">บันทึกรายการ Book bank</h4>
                  <div className="wpx-200">
                    <DatePicker
                      className="form-control w-100"
                      onChange={(e) => {
                        this.setState({ select_date: e });
                        setTimeout(() => this.Get(), 100);
                      }}
                      value={select_date}
                      min={format_date(new Date(new Date(start_date_statement).setDate(new Date(start_date_statement).getDate() - 1)), "yyyy-mm-dd", "en")}
                      max={format_date(max_date, "yyyy-mm-dd", "en")}
                      disabled={!save}
                    />
                  </div>
                </div>
                {!disabled && (
                  <div className="d-flex">
                    <div>
                      <button className="btn btn-primary px-5 text-nowrap" onClick={() => document.getElementById("file").click()}>นำเข้า bookbank</button><br />
                      <a href={excel_file} download="template นำเข้า bookbank.xlsx">template นำเข้า bookbank.xlsx</a>
                      <input className="d-none" type="file" id="file" accept=".xls,.xlsx" onChange={this.import_file} />
                      <div className="d-none">
                        <ReactExcel initialData={this.state.import_current} onSheetUpdate={(s) => this.setState({ currentSheet_current: s })} activeSheetClassName="d-none" reactExcelClassName="table table-borderless table-striped" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              
              <div className="card border-0 p-3 mb-3">
                <div className="row">
                  {/* Book bank Table */}
                  <div className="col-12 col-md-6 px-1">
                    <div className="d-flex justify-content-between">
                      <h5 className="mb-0 fw-bold">Book bank</h5>
                      <div className="mb-0 d-flex align-items-center">ยอดยกมา: <h5 className="mx-2 mb-0">{toFixed(balance_forward)}</h5> บาท</div>
                    </div>
                    <hr className="my-2" />
                    <div className="d-flex align-items-end justify-content-between mb-2">
                      <div className="d-flex align-items-center">
                        <label className="wpx-80">รวม</label>
                        <h4 className="mb-0 fw-bold">฿{toFixed(data_bookbank[data_bookbank.length - 1]?.balance || 0)}</h4>
                      </div>
                    </div>
                    <div className="table-responsive mb-2" style={{ maxHeight: "60vh" }}>
                      <table className="table table-bordered table-hover mb-0">
                        <thead>
                          <tr style={{ height: 46 }}>
                            <th className="text-nowrap align-middle bg-white sticky-top"></th>
                            <th className="text-nowrap align-middle bg-white sticky-top"></th>
                            <th className="text-nowrap align-middle bg-white sticky-top wpx-150">หมายเหตุ</th>
                            <th className="text-nowrap align-middle bg-white sticky-top">ผู้บันทึก</th>
                            <th className="text-nowrap align-middle bg-white sticky-top wpx-150">IW <span className="icon text-secondary ml-1 pointer" title="กดช่องเพื่อทำการเลือกช่อง IW เมื่อช่องเป็นสีเขียวแล้ว ให้ทำการกดเลือก รายการด้านขวาเพื่อเพิ่ม IW ใน statement นั้นๆ">{"\uf05a"}</span></th>
                            <th className="text-nowrap align-middle bg-white sticky-top wpx-120">สถานะ</th>
                            <th className="text-nowrap align-middle bg-white sticky-top">วันที่</th>
                            <th className="text-nowrap align-middle bg-white sticky-top">เวลา</th>
                            <th className="text-right text-nowrap align-middle bg-white sticky-top wpx-100">เงินเข้า</th>
                            <th className="text-right text-nowrap align-middle bg-white sticky-top wpx-100">เงินออก</th>
                            <th className="text-right text-nowrap align-middle bg-white sticky-top">คงเหลือ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data_bookbank.map((item, i) => (
                            <tr
                              key={"statement" + i}
                              draggable={!disabled}
                              onDragStart={() => this.onDragStart(i)}
                              onDragOver={this.onDragOver}
                              onDrop={() => this.onDrop(i)}
                              style={{ height: 46, cursor: "move", backgroundColor: i === draggedIndex ? "#f0f0f0" : "white" }}
                              className={item.iw_number ? "bg-white" : "bg-success-light"}
                            >
                              <td className="px-1 align-middle text-center">{!disabled && <label className="icon text-secondary pointer mb-0">{"\uf0c9"}</label>}</td>
                              <td className="px-1 align-middle">
                                {!disabled && (
                                  <label className="wpx-24 hpx-24 mb-0 bg-danger-light rounded-1 d-flex align-items-center justify-content-center">
                                    <label className="icon mx-2 text-danger pointer mb-0" onClick={() => {
                                      Swal.fire({
                                        icon: "warning", title: "ยืนยันการลบข้อมูล", text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่",
                                        showCancelButton: true, cancelButtonColor: "#d33", confirmButtonText: "ลบข้อมูล", cancelButtonText: "ยกเลิก"
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          if (item.bookbank_id) this.state.data_bookbank_remove.push(item.bookbank_id);
                                          data_bookbank.splice(i, 1);
                                          this.setState({ data_bookbank: this.updateBalances(), save: false });
                                        }
                                      });
                                    }}>{"\uf2ed"}</label>
                                  </label>
                                )}
                              </td>
                              <td className="p-0 ps-2 align-middle">
                                <div className="d-flex align-items-center h-100">
                                  <p className="w-100 mb-0" style={{ maxWidth: 150, maxHeight: 45, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.remark || " "}</p>
                                  <label className="icon mx-2 text-warning pointer mb-0" onClick={() => this.setState({ modal_remark: true, remark: item.remark, bookbank_index: i })}>{"\uf044"}</label>
                                </div>
                              </td>
                              <td className="text-right align-middle text-nowrap">{item.record_name[item.record_name.length - 1]?.name || ""}</td>
                              <td className="p-0 align-middle">
                                {!disabled && (
                                  item.iw_number ? (
                                    <div className="d-flex w-100 h-100 align-items-center justify-content-between px-1">
                                      <div className="text-nowrap">{item.iw_number}</div>
                                      <label className="icon mx-2 text-danger pointer mb-0" onClick={() => {
                                        data_bookbank[i].iw_number = "";
                                        this.setState({ data_bookbank, save: false });
                                      }}>{"\uf2ed"}</label>
                                    </div>
                                  ) : (
                                    <div className={`w-100 h-100 pointer p-1 d-flex align-items-center justify-content-center ${select_bookbank === i ? "bg-success text-light" : "text-secondary"}`} onClick={() => this.setState({ select_bookbank: select_bookbank === i ? -1 : i })}>
                                      {select_bookbank === i ? "กรุณาเลือก" : "ไม่ได้เลือก"}
                                    </div>
                                  )
                                )}
                              </td>
                              <td className="p-0 align-middle">
                                <select className="form-control border-0 bg-transparent w-100 p-1" value={item.status} disabled={disabled} onChange={(e) => {
                                  data_bookbank[i].status = e.target.value;
                                  this.setState({ data_bookbank, save: false });
                                }}>
                                  <option value=""></option><option value="1">ฝากประจำวัน</option><option value="2">เงินที่ลูกค้าโอน</option>
                                  <option value="3">รอออกใบเสร็จ</option><option value="4">เช็ค กคช.</option><option value="5">ตัดเช็ค คชจ.</option>
                                  <option value="6">จัดประโยชน์</option><option value="7">บังคับคดี</option><option value="8">ถอนเงิน</option>
                                </select>
                              </td>
                              <td className="align-middle px-1">{format_date(item.date, "dd/mm/yy")}</td>
                              <td className="p-0 align-middle">
                                <input type="time" className="form-control border-0 bg-transparent w-100 text-right p-1" value={item.time} ref={el => this.timeRefs[i + 1] = el} disabled={disabled} onKeyUp={(e) => this.handleInputEnter(e, i + 1, true)} onChange={(e) => {
                                  data_bookbank[i].time = e.target.value;
                                  this.setState({ data_bookbank, save: false });
                                }} />
                              </td>
                              <td className="p-0 align-middle">
                                <input type="text" className="form-control border-0 bg-transparent w-100 text-right p-1" placeholder="0.00" value={item.income} ref={el => this.inputRefs[i * 2 + 1] = el} disabled={disabled} onKeyUp={(e) => this.handleInputEnter(e, i * 2 + 1)} onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  data_bookbank[i].income = e.target.value.startsWith("0") ? e.target.value.slice(1) : e.target.value;
                                  this.setState({ data_bookbank: this.updateBalances(), save: false });
                                }} />
                              </td>
                              <td className="p-0 align-middle">
                                <input type="text" className="form-control border-0 bg-transparent w-100 text-right p-1" placeholder="0.00" value={item.outcome} ref={el => this.inputRefs[i * 2 + 2] = el} disabled={disabled} onKeyUp={(e) => this.handleInputEnter(e, i * 2 + 2)} onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  data_bookbank[i].outcome = e.target.value.startsWith("0") ? e.target.value.slice(1) : e.target.value;
                                  this.setState({ data_bookbank: this.updateBalances(), save: false });
                                }} />
                              </td>
                              <td className="text-right align-middle">{toFixed(item.balance || 0)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {!disabled && (
                      <button className="btn btn-info px-5" onClick={() => {
                        data_bookbank.push(this.getNewRow());
                        this.setState({ data_bookbank: this.updateBalances(), select_bookbank: data_bookbank.length - 1, save: false });
                      }}>+ เพิ่มรายการ</button>
                    )}
                  </div>

                  {/* การนำส่งเงิน Table */}
                  <div className="col-12 col-md-6 px-1">
                    <h5 className="mb-2 fw-bold">การนำส่งเงิน</h5>
                    <hr className="my-2" />
                    <div className="d-flex align-items-end justify-content-between mb-2">
                      <div className="d-flex align-items-center">
                        <label className="wpx-150">จำนวน {data_iw.length} รายการ</label>
                        <label className="wpx-80">รวม</label>
                        <h4 className="mb-0 fw-bold">฿{toFixed(total(data_iw, "total_final") || 0)}</h4>
                      </div>
                    </div>
                    <div className="table-responsive" style={{ maxHeight: "60vh" }}>
                      <table className="table table-bordered table-hover mb-0">
                        <thead>
                          <tr style={{ height: 46 }}>
                            {['วันเวลาที่โอนเงิน', 'ยอดใบเสร็จ', 'ห้องเลขที่', 'วันที่ใบเสร็จ', 'IW', 'RW', 'ประเภท'].map((th, idx) => (
                              <th key={idx} className={`text-nowrap align-middle bg-white sticky-top px-1 ${th === 'IW' || th === 'RW' ? 'text-center' : ''}`}>{th}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {data_iw.map((item, i) => (
                            <tr
                              key={"data" + i}
                              className={data_bookbank.some((e) => e.iw_number === item.iw_number) ? "pointer" : "pointer bg-danger text-white"}
                              style={{ height: 46 }}
                              onClick={() => {
                                if (select_bookbank !== -1) {
                                  data_bookbank[select_bookbank].iw_number = item.iw_number;
                                  this.setState({ data_bookbank, select_bookbank: data_bookbank[select_bookbank + 1]?.iw_number ? -1 : select_bookbank + 1, save: false });
                                }
                              }}
                            >
                              <td className="text-nowrap px-1 align-middle">{format_date(item.transfer_date, "dd/mm/yy")} {item.transfer_time?.slice(0, 5) || ""}</td>
                              <td className="text-nowrap text-right px-1 align-middle">{toFixed(item.total_final)}</td>
                              <td className="text-nowrap px-1 align-middle">{item.address_number}</td>
                              <td className="text-nowrap px-1 align-middle">{format_date(item.record_date, "dd/mm/yy")}</td>
                              <td className="text-nowrap px-1 align-middle text-center">{item.iw_number}</td>
                              <td className="text-nowrap px-1 align-middle text-center">{item.rw_number}</td>
                              <td className="text-nowrap px-1 align-middle">{item.record_other_list[0]?.title || ""}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Controls */}
          {!disabled && (
            <div className="body w-100 bg-white p-3 position-fixed d-flex justify-content-between" style={{ bottom: 0, left:0, zIndex: 10 }}>
              <button className="btn btn-primary px-5" onClick={this.CreateUpdate}>บันทึกข้อมูล</button>
              {((data_bookbank.length !== 0 && data_bookbank.every(e => e.bookbank_id) && save) || data_bookbank.length === 0) && (
                <div className="d-flex align-items-center">
                  <label className="mb-0">ยอดเงินสุดท้ายของ bookbank</label>
                  <input
                    type="text"
                    className="form-control wpx-200 mx-3"
                    placeholder="ยอดเงินสุดท้ายของ bookbank"
                    id="last_price"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ last_price: e.target.value });
                    }}
                    value={last_price}
                  />
                  <button
                    className="btn btn-dark px-5"
                    onClick={() => {
                      let targetBalance = data_bookbank.length === 0 ? balance_forward : (data_bookbank[data_bookbank.length - 1]?.balance || 0);
                      if (!last_price) {
                        alert("warning", "แจ้งเตือน", "กรุณากรอกยอดเงินสุดท้ายของ bookbank เพื่อยืนยันการส่งข้อมูล");
                        document.getElementById("last_price").focus();
                      } else if (Number(Number(last_price).toFixed(2)) === Number(targetBalance.toFixed(2))) {
                        this.SendData();
                      } else {
                        alert("warning", "แจ้งเตือน", "ยอดเงินสุดท้ายของ bookbank ไม่ตรงกันข้อมูลที่กรอก");
                        document.getElementById("last_price").focus();
                      }
                    }}
                  >
                    ส่งข้อมูล
                  </button>
                </div>
              )}
            </div>
          )}

          <Modal show={modal_remark} onHide={() => this.setState({ modal_remark: false })}>
            <Modal.Header><Modal.Title><b>แก้ไขหมายเหตุ</b></Modal.Title></Modal.Header>
            <Modal.Body>
              <div className="w-100 d-flex align-items-center mb-3">
                <label className="wpx-100">หมายเหตุ:</label>
                <textarea className="form-control bg-contain border-0" placeholder="พิมพ์คำค้นหา..." onChange={(e) => this.setState({ remark: e.target.value })} value={remark} />
              </div>
              <div className="w-100 d-flex">
                <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_remark: false })}>ยกเลิก</button></div>
                <div className="w-50 p-1"><button className="btn btn-primary w-100" onClick={() => {
                  data_bookbank[bookbank_index].remark = remark;
                  this.setState({ data_bookbank, modal_remark: false, save: false });
                }}>ยืนยัน</button></div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
        </div>
      );
    }
  }